import "../newProviderAppCSS/landing.css";
const Button = ({
   className = {},
   title,
   onClick = () => {},
   fullWidth = false,
   src = null,
   logoSocialClass = "",
   id = "button-new",
   disabled = false,
}) => {
   return (
      <button
         id={id}
         disabled={disabled}
         onClick={onClick}
         className={`button-commoon-new-app  ${fullWidth ? "full-width-new-app" : "custom-width-new-app"} ${className}`}
      >
         {src && <img className={logoSocialClass} src={src} alt="social-logo" />} {title}
      </button>
   );
};

export default Button;
